/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./BottomNavigation.css'); }
exports.BottomNavigation = function BottomNavigation(_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange;
    return (React.createElement("footer", { className: "m-bottomNavigation" },
        React.createElement("nav", { className: "m-bottomNavigation-content" }, options.map(function (option) { return (React.createElement("button", { key: option.value, role: "button", name: option.name, className: classnames({
                "m-bottomNavigation-button": true,
                "m-bottomNavigation-button-isActive": value === option.value
            }), type: "button", onClick: function (e) { return onChange(e, option.value); }, "aria-pressed": value === option.value },
            React.createElement(Icon_1.Icon, { type: option.iconType, size: 1 }),
            React.createElement("span", { className: "m-bottomNavigation-buttonLabel" }, option.label))); }))));
};
exports.BottomNavigation.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        name: PropTypes.string,
        iconType: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired
    })).isRequired
};